import {
  DELETE_TRADE_AGREEMENT_VALIDATOR_REQUEST,
  DELETE_TRADE_AGREEMENT_VALIDATOR_SUCCESS,
  DELETE_TRADE_AGREEMENT_VALIDATOR_FAIL,
} from '../actions/deleteTradeAgreementValidator';

const initialState = {
  loading: false,
};

const deleteTradeAgreementValidatorReducer = (state = initialState, action) => {
  const { type } = action;
  //const { validators, counter } = state;
  switch (type) {
    case DELETE_TRADE_AGREEMENT_VALIDATOR_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case DELETE_TRADE_AGREEMENT_VALIDATOR_SUCCESS:
    case DELETE_TRADE_AGREEMENT_VALIDATOR_FAIL:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};

export default deleteTradeAgreementValidatorReducer;
